import { useCallback, useEffect, useRef, useState } from 'react'
import getCoinValue from './actions/getCoinValue'

/**
 * The `useMaticToUSD` hook
 *
 * @param {number} interval - the interval in ms
 * @returns {number} the multiplier
 */
function useMaticToUSD (interval = 60000) {
  const [multiplier, setMultiplier] = useState(0)
  const isActiveRef = useRef(true)
  const timeoutRef = useRef()

  /**
   * Poll
   */
  const poll = useCallback(async () => {
    if (!isActiveRef.current) {
      return
    }

    try {
      const res = await getCoinValue()

      if (isActiveRef.current && res.success) {
        setMultiplier(res?.data?.price)
      }
    } catch (error) {
      console.error(error)
    }

    timeoutRef.current = setTimeout(poll, interval)
  }, [interval])

  /**
   * Effect: On mount/unmount
   */
  useEffect(() => {
    isActiveRef.current = true

    poll()

    return () => {
      isActiveRef.current = false
      clearTimeout(timeoutRef.current)
    }
  }, [poll])

  return multiplier
}

// Export
export default useMaticToUSD
